exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subtext[data-v-22be8493]{\n\tfont-size: 12px;\n\tfont-weight: normal;\n\tdisplay:flex;\n\tflex-wrap: wrap;\n\tjustify-content:left;\n}\n.thumbnail[data-v-22be8493]{\n\twidth:100%;\n\theight:100%;\n\tborder: 1px solid #ddd;\n\tborder-radius: 4px;\n\tpadding: 5px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-22be8493","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/techdoc.vue
// module id = 819
// module chunks = 0